import { useTranslation } from "react-i18next";
import { envChangeType } from "../../../../plugins/utils";
import styles from "./style.module.scss";

const AmountArea = ({ money, style }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.amountArea} style={{ ...style }}>
      <div className={styles.label}>{t("wallet.amountArea.label")}</div>
      <div className={styles.money}>
        {t(`currency.symbol.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`) + " " + money}
      </div>
    </div>
  );
};

export default AmountArea;
